export const NewChatIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 17"
    fill="none"
    {...props}
  >
    <path
      d="M3 14.4999C2.73333 14.4999 2.5 14.3999 2.3 14.1999C2.1 13.9999 2 13.7666 2 13.4999V3.49993C2 3.23327 2.1 2.99994 2.3 2.79993C2.5 2.59993 2.73333 2.49994 3 2.49994H9.75L8.75 3.49993H3V13.4999H13V7.69994L14 6.69993V13.4999C14 13.7666 13.9 13.9999 13.7 14.1999C13.5 14.3999 13.2667 14.4999 13 14.4999H3ZM6 10.4999V7.6666L12.3667 1.29993C12.4667 1.19993 12.5778 1.12771 12.7 1.08327C12.8222 1.03882 12.9444 1.0166 13.0667 1.0166C13.1889 1.0166 13.3129 1.0416 13.4387 1.0916C13.5643 1.1416 13.6792 1.2166 13.7833 1.3166L15.1667 2.7166C15.2623 2.81616 15.3362 2.92605 15.3883 3.04627C15.4406 3.1666 15.4667 3.28893 15.4667 3.41327C15.4667 3.53771 15.4417 3.66382 15.3917 3.7916C15.3417 3.91938 15.2667 4.03327 15.1667 4.13327L8.83333 10.4999H6ZM7 9.49994H8.41667L12.6333 5.28327L11.9167 4.58327L11.2 3.88327L7 8.0666V9.49994Z"
      fill="currentColor"
    />
  </svg>
);
